'use client';

import { useComparisonStore } from '@eliadmin/core/src/stores/comparison-store';
import { Carousel } from '../../ui/carousel';
import { ComparisonProduct } from './comparison-product';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Paragraph } from '../../ui/paragraph';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export function ComparisonProducts() {
  const { t } = useTranslations();
  const products = useComparisonStore(s => s.products);
  const removeProduct = useComparisonStore(s => s.removeProduct);
  const clearAll = useComparisonStore(s => s.clearAll);

  const hasProducts = products.length > 0;

  if (!hasProducts) {
    return <Paragraph className="mt-12 w-full text-center">{t('text3747')}</Paragraph>;
  }

  return (
    <div className={cn('custom-container')}>
      <Carousel
        className={{
          wrapper: 'w-full',
          container: 'w-full gap-4 sm:gap-5 lg:gap-6',
          main: 'w-full',
          slide: 'w-full max-w-[320px] sm:max-w-[332px]',
        }}
        slides={products.map(product => (
          <ComparisonProduct product={product} key={product.slug} />
        ))}
      />
    </div>
  );
}
